/*globals $*/
'use strict';

import { initContactForm } from './contact';

const getValidationFunctions = () => import("./validate");

document.addEventListener('DOMContentLoaded', function () {
   initContactForm();

   const submitButton = document.querySelector('#webcooking__contact-form #webcooking__contact_submit-button');
   if (submitButton) {
      submitButton.addEventListener('click', function (e) {
         e.preventDefault();
         getValidationFunctions().then(validateModule => {
            validateModule.validateContactForm();
         });
      });
   }

   const newsletterForm = document.getElementById('webcooking__newsletter-form');
   if (newsletterForm) {
      newsletterForm.addEventListener('submit', function (e) {
         e.preventDefault();
         getValidationFunctions().then(validateModule => {
            validateModule.validateNewsletterForm();
         });
      });
   }
});
